import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import Modal2Provider from "core/Modal2";
import Message from "./Message";
import Modal from "./Modal/index.js";

// styles
import breakpoints from "core/breakpoints";
const MarketingMessageModalStyled = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        display: none;
    }
`;

// component
export const MarketingMessageModal = ({ userMessage }) => {
    return (
        <MarketingMessageModalStyled>
            <Modal2Provider>
                <Message userMessage={userMessage} />
                <Modal userMessage={userMessage} />
            </Modal2Provider>
        </MarketingMessageModalStyled>
    );
};

export default MarketingMessageModal;

// prop-types
MarketingMessageModal.propTypes = {
    userMessage: PropTypes.object
};
